import { render, staticRenderFns } from "./OPPayable.vue?vue&type=template&id=3f481534&"
import script from "./OPPayable.vue?vue&type=script&lang=js&"
export * from "./OPPayable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports